<p>auth-redirect works!</p>
